<script setup lang="ts">
import EstateEquipmentItem from './EstateEquipmentItem.vue'
import type { EstateDetailInterface } from '~/types/api/EstateDetail'

const props = defineProps<{
  estateData: EstateDetailInterface
}>()

const isEquipmentVisible = computed(() => {
  return props.estateData.benefits.length > 0
})
</script>

<template>
  <div v-if="isEquipmentVisible" class="c-estate-equipment">
    <h2 class="c-estate-equipment__title h4">
      {{ $t(`pages.estateDetail.equipment.title.${estateData.type}`) }}
    </h2>

    <div class="c-estate-equipment__content">
      <EstateEquipmentItem
        v-for="item in estateData.benefits"
        :key="item.name"
        :item="item"
        :estate-type="estateData.type"
      />
    </div>

    <!-- <div class="c-estate-equipment__more">
      <button class="c-link c-link--with-leading-bar">
        <strong>{{ $t('pages.estateDetail.equipment.showMore') }}</strong>
      </button>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-estate-equipment {
  &__title {
    margin-bottom: 18px;
  }

  &__content {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px 13px;
    margin-bottom: 40px;

    @include breakpoint-down('md') {
      grid-template-columns: repeat(3, 1fr);
    }

    @include breakpoint-down('sm') {
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
      margin-bottom: 18px;
    }
  }

  &__more {
    @include breakpoint-down('sm') {
      font-size: 16px;
    }
  }
}
</style>
